'use strict';

const Analytics = require('./analytics');
var helper = require('./helpers/helper');

function getTheSkusOfTheProducts () {
    if ($('.analytics.checkout.checkout-product').length > 0) {
        return $('.analytics.checkout.checkout-product').toArray()
            .map((e) => {
                return helper.getFormatSku($(e).data('item_sfcc'));
            })
            .join('-');
    } else if ($('.analytics.product.hidden').length > 0) {
        let sku = decodeURI($('.product-detail.product-detail-keeper').data('pid'));
        return helper.getFormatSku(sku);
    } else {
        return 'no_products';
    }
}

class AnalyticsFindYourStore extends Analytics {
    init (globalContainer, helperContainer) {
        this.logName = 'Analytics Find your Store';

        super.init(globalContainer, helperContainer);
        this.prepareObservers();
        this.prepareStoresObservers();
    }

    prepareObservers () {
        var _self = this;

        $('body').on('storeLocator:searchWithZipCode', function (e, data) {
            let sku = getTheSkusOfTheProducts();
            let city = _self.helper.formatNameForAnalytics(data.city);
            _self.quickImpressionSender.pushFindStoreFindInteraction(city.replaceAll(',', '') || '', sku, data.action || '');
        });

        $('body').on('storeLocator:geolocationSucceeded', function (e, data) {
            let city = $('.js-store-city').eq(0).html() || '';
            if (!city) {
                city = $('.store-result').find('.store-map').eq(0).text().replace(/\s+/gm, ' ').trim();
            }
            let sku = getTheSkusOfTheProducts();
            _self.quickImpressionSender.pushFindStoreGeolocationImpression(city.replaceAll(',', ''), sku, data.action || '');
        });
    }

    prepareStoresObservers () {
        var _self = this;

        $('body').on('click', '.store-locator-container a, .store-details a, .storelocator-phone, .store-page-details-right a, .store-name-link a, .store-result-marker-button, .item-nearby-store-box a', function (e) {
            let action = $(e.currentTarget).data('name');
            if (!action || (action === 'see_the_opening_hours' && $(e.currentTarget).closest('.store-hours').find('.store-hours-list').hasClass('hidden'))) {
                return;
            }
            let storeName = $(e.currentTarget).closest('.store-result').find('.analytics-store-name').text();
            if (!storeName) {
                storeName = $(e.currentTarget).data('analytics-name');
            }
            storeName = _self.helper.formatString(storeName);
            let sku = $('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products';
            let where = (sku !== 'no_products') ? 'search_for_products_in_the_store' : ($('.findinstore').length > 0) ? 'shipping_method' : 'search_for_a_shop';
            _self.quickImpressionSender.pushFindStoreClickResultAction(action, storeName, sku, where);
        });

        $('body').on('analytics:clickonStoreMarker', function (e, item) {
            let action = 'view_in_map';
            let storeName = _self.helper.formatString(item.name);
            let sku = getTheSkusOfTheProducts();
            let where = (sku === 'no_products') ? 'search_for_a_shop' : (($('.page').data('action').split('-')[0] === 'Checkout') ? 'shipping_method' : 'search_for_products_in_the_store');
            _self.quickImpressionSender.pushFindStoreClickResultAction(action, storeName, sku, where);
        });

        $('body').on('STANDARD:selectedPickup', function (e, data) {
            let storeName = _self.helper.formatString(data.name);
            let sku = getTheSkusOfTheProducts();
            _self.quickImpressionSender.pushFindStoreClickResultAction('click_result_of_the_shops_listing', storeName, sku, 'shipping_method');
        });

        $('body').on('click', '#checkout-main #findinstore div[role="dialog"] .storelocator-phone ', function (e) {
            let action = 'phone_number';
            let storeName = $(e.currentTarget).closest('div[role="dialog"]').find('.store-name').text();
            storeName = _self.helper.formatString(storeName);
            let sku = getTheSkusOfTheProducts();
            let where = 'shipping_method';
            _self.quickImpressionSender.pushFindStoreClickResultAction(action, storeName, sku, where);
        });

        $('body').on('click', '#findinstore a, #findinstore .js-findinstorepdp', function (e) {
            if ($(e.currentTarget).attr('id') === 'findinstore-usecurrentposition') {
                return;
            }

            let action = $(e.currentTarget).data('name');
            if (action === 'see_the_opening_hours' && $(e.currentTarget).siblings('.store-hours-list').hasClass('hidden')) {
                return;
            }

            let storeName = $(e.currentTarget).closest('.result').data('store-name');
            if (!storeName) {
                storeName = $(e.currentTarget).data('store-name');
            }
            let sku = getTheSkusOfTheProducts();
            let where = $('.page').data('action') === 'Product-Show' ? 'search_for_products_in_the_store' : 'shipping_method';
            _self.quickImpressionSender.pushFindStoreClickResultAction(action, _self.helper.formatString(storeName), sku, where);
        });

        $('body').on('click', '.cc-pdp__findInStoreModal .analytics-storeActions', function (e) {
            let action = $(e.currentTarget).data('name');
            let storeName = $(e.currentTarget).closest('.cc-pdp__findInStoreModal__body').data('store-name');
            let sku = getTheSkusOfTheProducts();
            _self.quickImpressionSender.pushFindStoreClickResultAction(action, _self.helper.formatString(storeName), sku, 'search_for_products_in_the_store');
        });

        $('body').on('click', '.findinstore-results .js-choose-store', function (e) {
            let action = 'click_result_of_the_shops_listing';
            let storeName = $(e.currentTarget).closest('.js-store-row').find('.store-name').text();
            storeName = _self.helper.formatString(storeName);
            let sku = getTheSkusOfTheProducts();
            let where = 'shipping_method';
            _self.quickImpressionSender.pushFindStoreClickResultAction(action, storeName, sku, where);
        });

        $('body').on('storeLocator:searchStoreFromPDPSucceed', function (e, data) {
            let sku = getTheSkusOfTheProducts();
            _self.quickImpressionSender.pushFindStoreFindInteraction(data.city, sku, data.action);
        });

        $('body').on('storeLocator:geolocalizeFromPDPSucceed', function (e, data) {
            let where = $('.js-store-city').eq(0).html() || '';
            let sku = getTheSkusOfTheProducts();
            _self.quickImpressionSender.pushFindStoreGeolocationImpression(where, sku, data.action);
        });

        $('body').on('click', '.js-choose-point, .js-choose-pickupPointBPOST', function (e) {
            let storeName = _self.helper.formatString($(e.currentTarget).data('store-name'));
            let sku = $('.analytics.checkout.checkout-product').length > 0 ? $('.analytics.checkout.checkout-product').toArray()
                .map((e) => {
                    return _self.helper.getFormatSku($(e).data('item_sfcc'));
                })
                .join('-') : ($('.product-detail').length > 0 ? decodeURIComponent($('.product-detail').attr('data-variant-pid')) : 'no_products');
            _self.quickImpressionSender.pushFindStoreClickResultAction('click_result_of_the_shops_listing', storeName, sku, 'shipping_method');
        });
    }
}

const obj = new AnalyticsFindYourStore();
module.exports = obj;
